import { useTrackingEventsDatas } from "@/hooks";
import { useTrackingEvent } from "./useTrackingEvent";
export const useTrackingLeadForm = ({ event, av_zone, }) => {
    const EVENT_DATA = Object.assign(Object.assign({}, useTrackingEventsDatas({
        displayMedium: true,
        conversionType: "mail",
        av_zone,
    })), { event });
    // @ts-ignore
    return useTrackingEvent(EVENT_DATA);
};
